module.exports = __webpack_public_path__ + "assets/audio/JetStartup_01.wav";